import { Component, OnInit } from '@angular/core';
import { InterviewResourceIdentifier } from '@Components/mras/core';
import { NavigationExtras, Router } from '@angular/router';

@Component({
    selector: 'jhi-interview-bootstrap',
    templateUrl: './interview-bootstrap.component.html',
    styles: []
})
export class InterviewBootstrapComponent implements OnInit {
    resourceIdentifier: InterviewResourceIdentifier;
    options: string[];

    constructor(private router: Router) {}

    ngOnInit() {
        this.resourceIdentifier = new InterviewResourceIdentifier();
    }

    onSubmit() {
        const path = `mras/interview/edit/caseId/${this.resourceIdentifier.caseId}/lifeInstance/${
            this.resourceIdentifier.lifeInstance
        }/interviewCode/${this.resourceIdentifier.interviewCode}`;
        const navigationExtras: NavigationExtras = {
            queryParams: { interviewInstance: this.resourceIdentifier.interviewInstance }
        };
        this.router.navigate([path], navigationExtras);
    }
}
